export default function scrollTop(id=null){
  const y = (id === null)?  0 : Math.floor( window.pageYOffset + document.getElementById(id).getBoundingClientRect().top )

  window.scrollTo({
    top: y,
    behavior: 'smooth'
  })
}
